export const useFetchCollectionsForFeedbackRecord = () => {
  return {
    collections: [],
    isLoading: true,
  };
};
